import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleScale5',
  setup(__props) {

// this component is a thin layer on top of v-btn-toggle that convert `1 - 5` to `0 - 4`

return { __sfc: true, }
}

})